import React from 'react';

export const Clock = React.memo(({ fill }) => (
  <>
    <circle cx='12' cy='12' r='10' stroke={fill} strokeWidth='1.5' />
    <path
      d='M12 8V12L14.5 14.5'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </>
));
Clock.displayName = 'Clock';
